import {history} from '../helpers'
import api from '../constants/api';
import { authHeader, setCookie, getCookie, delete_cookie } from '../helpers';

export function checkError(response) {
    let error = true;
    if (response && response.statusCode) {
        if ( (response.statusCode === 400) ) {
            localStorage.removeItem('user');
            sessionStorage.removeItem('user');
            history.push('/index.html?p=login');
            // window.location.href = '/index.html?p=login';
        }
        if ( (response.statusCode === 302) ) {
            ;
        }
        error = response.statusCode !== 200;
    }
    return error;
};

export async function checkToken(response)  {
    if (response.data.statusCode === 502) {
      let user = {};
      if (localStorage.getItem('user')) {
        user = JSON.parse(localStorage.getItem('user'));
      } else if (sessionStorage.getItem('user')) {
        user = JSON.parse(sessionStorage.getItem('user') || '{}');
      };
      try {
        let tmp_refresh_token = getCookie('refresh_token');
        const result = await refreshAccessToken(tmp_refresh_token);
        console.log("result:", result);

        user.token = result.data.token;
        // user.refresh_token = result.data.refresh_token;
        setCookie('refresh_token', result.data.refresh_token);

        localStorage.setItem('user', JSON.stringify(user));
        sessionStorage.setItem('user', JSON.stringify(user));

        return true;
      } catch (error) {
        console.error("Refresh token failed:", error);

        // logout nếu cần
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        delete_cookie('refresh_token');
        window.location.href = '/index.html?p=login';

        return false;
      };
    };
    return false;
};

const refreshAccessToken = async (refreshToken) => {
  try {
    const response = await fetch(api.url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        process_type: "createToken",
        refreshToken: refreshToken
      })
    });
  
    const data = await response.json();
  
    if (!response.ok) {
      throw new Error(data.message || 'Failed to refresh access token');
    }
  
    return data;

  } catch (error) {
    console.error("refreshAccessToken error:", error);
    throw error;
  };

};